import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Trash2 } from "lucide-react";

export default function AdminAffiliates() {
  const [aff, setAff] = useState([]);
  const [deletingId, setDeletingId] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get("/affiliate/admin/all").then((r) => setAff(r.data));
  }, []);

  const handleDeleteAffiliate = async (affiliate) => {
    const label = `${affiliate.name || "Cet affilié"} (${affiliate.email || affiliate.code || "sans email"})`;
    const confirmed = window.confirm(
      `Supprimer l'affilié ${label} ?\n\nCette action supprime son code affilié, ses clics et ses commissions associées.`
    );

    if (!confirmed) return;

    setError("");
    setDeletingId(affiliate.user_id);

    try {
      await api.delete(`/affiliate/admin/${affiliate.user_id}`);
      setAff((prev) => prev.filter((item) => item.user_id !== affiliate.user_id));
      window.location.reload();
    } catch (err) {
      const message = err?.response?.data?.detail || "Impossible de supprimer cet affilié.";
      setError(message);
    } finally {
      setDeletingId(null);
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-4 py-12" data-testid="admin-affiliates-page">
      <p className="label">Admin</p>
      <h1 className="font-heading text-3xl font-black mb-6">Ambassadeurs & commissions</h1>

      {error && (
        <div className="mb-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
          {error}
        </div>
      )}

      {/* Mobile : une fiche par affilie, tout visible en defilant vers le bas. */}
      <div className="space-y-3 lg:hidden">
        {aff.length === 0 && <p className="card p-8 text-center text-gray-500">Aucun affilié pour le moment.</p>}
        {aff.map((a) => (
          <div key={a.user_id} className="card p-4" data-testid={`admin-affiliate-card-${a.user_id}`}>
            <div className="flex items-start justify-between gap-3">
              <div className="min-w-0">
                <p className="font-heading font-bold break-words">{a.name || "—"}</p>
                <p className="break-all text-sm text-gray-500">{a.email}</p>
                <p className="mt-1 font-mono text-xs text-gray-600">{a.code}</p>
              </div>
              <button
                type="button"
                onClick={() => handleDeleteAffiliate(a)}
                disabled={deletingId === a.user_id}
                className="shrink-0 rounded-lg p-2 text-red-500 transition hover:bg-red-50 hover:text-red-700 disabled:opacity-50"
                title="Supprimer cet affilié"
                aria-label={`Supprimer l'affilié ${a.name || a.email || a.code}`}
              >
                <Trash2 className="h-4 w-4" />
              </button>
            </div>
            <dl className="mt-3 grid grid-cols-2 gap-y-2 border-t border-emerald-100 pt-3 text-sm">
              <dt className="text-gray-500">Clics</dt>
              <dd className="text-right font-semibold">{a.clicks}</dd>
              <dt className="text-gray-500">Conversions</dt>
              <dd className="text-right font-semibold">{a.conversions}</dd>
              <dt className="text-gray-500">Total gagné</dt>
              <dd className="text-right font-bold text-brand-green">{(a.total_earned_eur || 0).toFixed(2)}€</dd>
            </dl>
          </div>
        ))}
      </div>

      <div className="card overflow-hidden hidden lg:block">
        <div>
          <table className="w-full text-sm">
            <thead className="bg-emerald-50">
              <tr>
                <th className="text-left p-3">Nom</th>
                <th className="text-left p-3">Email</th>
                <th className="text-left p-3">Code</th>
                <th className="text-right p-3">Clics</th>
                <th className="text-right p-3">Conversions</th>
                <th className="text-right p-3">Total gagné</th>
                <th className="text-right p-3">Actions</th>
              </tr>
            </thead>
            <tbody>
              {aff.map((a) => (
                <tr
                  key={a.user_id}
                  className="border-t border-emerald-100"
                  data-testid={`admin-affiliate-${a.user_id}`}
                >
                  <td className="p-3">{a.name}</td>
                  <td className="p-3">{a.email}</td>
                  <td className="p-3 font-mono">{a.code}</td>
                  <td className="p-3 text-right">{a.clicks}</td>
                  <td className="p-3 text-right">{a.conversions}</td>
                  <td className="p-3 text-right font-bold text-brand-green">
                    {(a.total_earned_eur || 0).toFixed(2)}€
                  </td>
                  <td className="p-3 text-right">
                    <button
                      type="button"
                      onClick={() => handleDeleteAffiliate(a)}
                      disabled={deletingId === a.user_id}
                      className="inline-flex items-center justify-center rounded-lg p-2 text-red-500 transition hover:bg-red-50 hover:text-red-700 disabled:cursor-not-allowed disabled:opacity-50"
                      title="Supprimer cet affilié"
                      aria-label={`Supprimer l'affilié ${a.name || a.email || a.code}`}
                      data-testid={`delete-affiliate-${a.user_id}`}
                    >
                      <Trash2 className="h-4 w-4" />
                    </button>
                  </td>
                </tr>
              ))}

              {aff.length === 0 && (
                <tr>
                  <td colSpan={7} className="p-8 text-center text-gray-500">
                    Aucun affilié pour le moment.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* ✅ FIN DU SCROLL MOBILE */}
      </div>
    </div>
  );
}